import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ffcebee"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  class: "title pb-1 fw-bold"
}
const _hoisted_3 = {
  key: 2,
  class: "title pb-1 fw-bold"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 align-top"
}, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 align-top"
}, null, -1))
const _hoisted_10 = { key: 2 }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 align-top"
}, null, -1))
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  "aria-hidden": "true",
  class: "flycon flycon-start flycon-16 flycon-info border-0 align-top"
}, null, -1))
const _hoisted_15 = { key: 3 }
const _hoisted_16 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.spacing)
  }, [
    (_ctx.heading !== '')
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "title pb-1 fw-bold",
          innerHTML: _ctx.heading
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.label !== '' && _ctx.dateFrom == '' && _ctx.dateUntil == '')
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.dateFrom !== '' || _ctx.dateUntil !== '')
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          (_ctx.dateFrom !== '' && _ctx.dateUntil == '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode(" ab " + _toDisplayString(_ctx.moment(_ctx.dateFrom).format(_ctx.f)) + " ", 1),
                (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.dateFromDescription))
                  ? (_openBlock(), _createBlock(_component_Popper, {
                      key: 0,
                      hover: "",
                      arrow: "",
                      "append-to-body": "true",
                      placement: "top",
                      class: _normalizeClass(["border-0 m-0 popper-wrapper position-relative align-top", _ctx.tooltipWrapperClass])
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "popper-content",
                          innerHTML: _ctx.dateFromDescription
                        }, null, 8, _hoisted_5)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.dateUntil !== '' && _ctx.dateFrom == '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                _createTextVNode(" bis " + _toDisplayString(_ctx.moment(_ctx.dateUntil).format(_ctx.f)) + " ", 1),
                (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.dateUntilDescription))
                  ? (_openBlock(), _createBlock(_component_Popper, {
                      key: 0,
                      hover: "",
                      arrow: "",
                      "append-to-body": "true",
                      placement: "top",
                      class: _normalizeClass(["border-0 m-0 popper-wrapper position-relative align-top", _ctx.tooltipWrapperClass])
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "popper-content",
                          innerHTML: _ctx.dateUntilDescription
                        }, null, 8, _hoisted_8)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.dateUntil !== '' && _ctx.dateFrom !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.moment(_ctx.dateFrom).format(_ctx.f)) + " ", 1),
                (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.dateFromDescription))
                  ? (_openBlock(), _createBlock(_component_Popper, {
                      key: 0,
                      hover: "",
                      arrow: "",
                      "append-to-body": "true",
                      placement: "top",
                      class: _normalizeClass(["border-0 m-0 popper-wrapper position-relative align-top", _ctx.tooltipWrapperClass])
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "popper-content",
                          innerHTML: _ctx.dateFromDescription
                        }, null, 8, _hoisted_11)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true),
                _createTextVNode(" – " + _toDisplayString(_ctx.moment(_ctx.dateUntil).format(_ctx.f)) + " ", 1),
                (_ctx.stringHelper.isHtmlStringNotEmpty(_ctx.dateUntilDescription))
                  ? (_openBlock(), _createBlock(_component_Popper, {
                      key: 1,
                      hover: "",
                      arrow: "",
                      "append-to-body": "true",
                      placement: "top",
                      class: _normalizeClass(["border-0 m-0 popper-wrapper position-relative align-top", _ctx.tooltipWrapperClass])
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "popper-content",
                          innerHTML: _ctx.dateUntilDescription
                        }, null, 8, _hoisted_13)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["class"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.dateInterval !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, " | " + _toDisplayString(_ctx.dateFormatter.getFormattedIntervalValue(_ctx.dateInterval)), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("p", {
      class: "mb-0",
      innerHTML: _ctx.formatedContent
    }, null, 8, _hoisted_16)
  ], 2))
}